import { createAction, createReducer } from '@reduxjs/toolkit';
import UtmTracking from 'types/UtmTracking';

const utmTrackingReceived = createAction<UtmTracking>('utmTracking/received');

const utmTrackingReducer = createReducer(
  {},
  {
    [utmTrackingReceived.type]: (state, action) => {
      return action.payload;
    },
  }
);

export { utmTrackingReducer, utmTrackingReceived };
